import classNames from '@utils/classnames';

export interface IHorizontalRuleProps {
  className?: string;
}

export const HorizontalRule: React.FC<IHorizontalRuleProps> = ({ className }) => {
  return <div className={classNames('h-px w-full bg-border', className)}></div>;
};
